import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { MatDialog } from "@angular/material";
import * as moment from "moment";
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { AddOfframpAddressMappingDialog } from "./add-offramp-address-mapping/add-offramp-address-mapping.component";

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50,
  },
};

@Component({
  selector: "app-offramp-address-mappings",
  templateUrl: "./offramp-address-mappings.component.html",
  styleUrls: ["./offramp-address-mappings.component.css"],
})
export class OfframpAddressMappingsComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  oMappings: any = [];
  mappings: any = [];
  searchValue: string = '';
  filter: any = {
    page: 1,
    limit: 100,
  };
  prev_disabled = true;
  next_disabled = false;

  customerList: any[] = [];
  selectedUserId: string = '';

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  loadCustomerList() {
    const filter = {
      _csrf: this._csrf,
      perpage: 10000,
      page: 1,
      search: '',
      status: 'Active',
    };

    this.offrampService.getOfframpCustomerList(filter).subscribe(
      (response: any) => {
        if (response && response.customers && Array.isArray(response.customers)) {
          this.customerList = response.customers;
        } else if (response && Array.isArray(response)) {
          this.customerList = response;
        } else if (response && response.data && Array.isArray(response.data)) {
          this.customerList = response.data;
        } else {
          this.customerList = [];
        }
      },
      () => {
        this.customerList = [];
        this.notifSer.error('Error', 'Failed to load user list', defaults.notif);
      }
    );
  }

  onUserFilterChange(userId: string) {
    this.selectedUserId = userId || '';
    this.filter.userid = this.selectedUserId;
    this.filter.page = 1;
    this.getData();
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';

          const editBtn = document.createElement('button');
          editBtn.type = 'button';
          editBtn.className = 'btn btn-sm btn-primary';
          editBtn.title = 'Edit';
          editBtn.style.marginRight = '5px';
          editBtn.innerHTML = '<i class="fa fa-edit"></i>';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            this.editRecord(element);
          };
          container.appendChild(editBtn);

          const deleteBtn = document.createElement('button');
          deleteBtn.type = 'button';
          deleteBtn.className = 'btn btn-sm btn-danger';
          deleteBtn.title = 'Delete';
          deleteBtn.innerHTML = '<i class="fa fa-trash"></i>';
          deleteBtn.onclick = (e) => {
            e.stopPropagation();
            this.deleteRecord(element);
          };
          container.appendChild(deleteBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 110
      },
      {
        headerName: 'User',
        field: 'userid',
        valueGetter: (params) => {
          const user = params.data && params.data.userid;
          if (user && typeof user === 'object') {
            return `${user.name || ''} (${user.email || ''})`;
          }
          return user || '';
        },
        flex: 1.5,
        minWidth: 180
      },
      {
        headerName: 'Admin',
        field: 'adminid',
        valueGetter: (params) => {
          const admin = params.data && params.data.adminid;
          if (admin && typeof admin === 'object') {
            return `${admin.name || ''} (${admin.email || ''})`;
          }
          return admin || '';
        },
        flex: 1.5,
        minWidth: 180
      },
      {
        headerName: 'Network',
        field: 'network',
        flex: 1,
        minWidth: 110
      },
      {
        headerName: 'Currency',
        field: 'currency',
        flex: 1,
        minWidth: 110
      },
      {
        headerName: 'From Address',
        field: 'from_address',
        autoHeight: true,
        cellRenderer: (params) => this.renderAddress(params.data && params.data.from_address_name, params.value),
        sortable: false,
        filter: false,
        flex: 2,
        minWidth: 220
      },
      {
        headerName: 'To Address',
        field: 'to_address',
        autoHeight: true,
        cellRenderer: (params) => this.renderAddress(params.data && params.data.to_address_name, params.value),
        sortable: false,
        filter: false,
        flex: 2,
        minWidth: 220
      },
      {
        headerName: 'CreatedAt',
        field: 'createdAt',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 1.5,
        minWidth: 160
      }
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40
    };
  }

  renderAddress(name: string, address: string): string {
    if (!address) {
      return '<span style="color:#999;">No address</span>';
    }
    return `<div style="white-space:normal; line-height:1.4; padding:6px 0;">
        ${name ? `<b>${name}</b><br>` : ''}${address}
      </div>`;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.loadCustomerList();
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, defaults.notif);
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  applyFilter(filterValue) {
    this.searchValue = filterValue || '';
    this.filter.page = 1;
    this.getData();
  }

  clearSearch() {
    this.searchValue = '';
    this.applyFilter('');
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.filter.search = this.searchValue;
    this.offrampService.getAllOfframpAddressMappings(this.filter).subscribe((response: any) => {
      const list = (response && response.data) || [];
      this.mappings = list;
      this.oMappings = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
      }

      this.spinnerService.hide();
      this.prev_disabled = this.filter.page <= 1;
      this.next_disabled = !list || list.length < this.filter.limit;
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch address mappings", defaults.notif);
    });
  }

  resetFilters() {
    this.filter = { page: 1, limit: 100 };
    this.searchValue = '';
    this.selectedUserId = '';
    this.getData();
  }

  addNewRecord() {
    const newRecord = {
      adminid: '',
      network: '',
      currency: '',
      from_address_name: '',
      from_address: '',
      to_address_name: '',
      to_address: ''
    };

    const dialogRef = this.dialog.open(AddOfframpAddressMappingDialog, {
      width: '750px',
      data: { record: newRecord, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Address mapping added successfully", defaults.notif);
        this.getData();
      }
    });
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(AddOfframpAddressMappingDialog, {
      width: '750px',
      data: { record: record, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Address mapping updated successfully", defaults.notif);
        this.getData();
      }
    });
  }

  deleteRecord(record: any) {
    this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete this address mapping?`,
        buttonText: { ok: 'Yes', cancel: 'No' }
      }
    }).afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.spinnerService.show();
        this.offrampService.deleteOfframpAddressMapping({ _id: record._id, _csrf: this._csrf }).subscribe(
          (response: any) => {
            this.spinnerService.hide();
            if (response.status || response.success) {
              this.notifSer.success("Success", response.message || "Address mapping deleted successfully", defaults.notif);
              this.getData();
            } else {
              this.notifSer.error("Error", response.message || "Failed to delete address mapping", defaults.notif);
            }
          },
          (error) => {
            this.spinnerService.hide();
            this.notifSer.error("Error", (error.error && error.error.message) || "Failed to delete address mapping", defaults.notif);
          }
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-address-mappings/offramp-address-mappings.component.ts